module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dataLoaded) ? _c('div', {
    staticClass: "client-item-box j_client_item",
    attrs: {
      "data-trackdata": _vm.tData
    }
  }, [_c('div', {
    staticClass: "image-index-box",
    on: {
      "click": _vm.imageAction
    }
  }, [(_vm.containerWidth) ? _c('beast-image', {
    staticClass: "img",
    attrs: {
      "lazy": true,
      "image": _vm.data.image,
      "containerWidth": _vm.containerWidth
    }
  }) : _vm._e(), _vm._v(" "), (_vm.blockColor) ? _c('div', {
    staticClass: "block-box",
    style: ({
      'background': _vm.blockColor
    })
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-box"
  }, _vm._l((_vm.items), function(item) {
    return _c('p', {
      staticClass: "text-item",
      style: ({
        'color': item.textColor
      })
    }, [_vm._v(_vm._s(item.text))])
  }), 0)], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db4d663e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/renderer-config/components/image-index.vue
// module id = 650
// module chunks = 1 14